export const CampaignCreationSteps = {
  BRAND: 1,
  PRODUCTS: 2,
  AD_FORMAT: 3,
  MARKETS_AND_MERCHANTS: 4,
  PLACEMENT: 5,
  BUDGET: 6,
  REVIEW_AND_LAUNCH: 7,
} as const;
